import { useEffect, useState } from "react";
import "../Admin/admin.css";

const API = "https://suivi.amservices.eu/api";

export default function ArchivesPrets() {
    const [archives, setArchives] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadArchives = async () => {
        setLoading(true);
        try {
            // Créer ce fichier PHP qui fait : SELECT * FROM prets WHERE etat = 'archive'
            const r = await fetch(`${API}/get_archives_prets.php`, { credentials: "include" });
            const d = await r.json();
            if (d.success) setArchives(d.data);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadArchives() }, []);

    const restore = async (id) => {
        // Le script de restauration remet l'état à 'rendu' ou 'sorti'
        await fetch(`${API}/restore_pret.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id })
        });
        loadArchives();
        alert("Prêt restauré ✔");
    };

    const remove = async (id) => {
        if (!window.confirm("Supprimer définitivement ce record de prêt ?")) return;
        await fetch(`${API}/delete_pret_permanent.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id })
        });
        loadArchives();
    };

    return (
        <div className="admin-page">
            <div className="page-content">
                <h1>📦 Archives des Prêts</h1>

                {loading && <p style={{ textAlign: 'center' }}>Chargement...</p>}

                <table className="repair-table">
                    <thead>
                        <tr>
                            <th>Client</th>
                            <th>Téléphone</th>
                            <th>Matériel prêté</th>
                            <th>Retour prévu</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {archives.length === 0 && !loading && (
                            <tr><td colSpan="5" style={{ textAlign: 'center' }}>Aucune archive</td></tr>
                        )}
                        {archives.map(a =>
                            <tr key={a.id}>
                                <td><strong>{a.client_nom}</strong></td>
                                <td>{a.client_tel}</td>
                                <td>{a.materiel}</td>
                                <td>{new Date(a.date_retour_prevue).toLocaleDateString('fr-FR')}</td>
                                <td className="actions-menu">
                                    <button title="Restaurer" className="btn-recup" onClick={() => restore(a.id)}>↩</button>
                                    <button title="Supprimer définitivement" className="btn-archive" onClick={() => remove(a.id)}>🗑</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}